module.exports = __webpack_public_path__ + "img/border-large.d0dad3e4.png";